import React, { useEffect } from 'react';
import '../my-account/order-details/modals/modal-styles.css';
export interface IModalChildProps {
    onClose: () => void;
    onAccept: () => void;
}
interface IModalProps {
    children: JSX.Element;
}

export const ModalXLarge = ({ children }: IModalProps) => {
    const body = document.body;
    const background = document.createElement('div');

    useEffect(() => {
        background.className = 'modal-backdrop fade in';
        if (!body.classList.contains('modal-open')) {
            body.classList.add('modal-open');
            body.appendChild(background);
            body.style.paddingRight = '17px';
        }

        return () => {
            if (body.classList.contains('modal-open')) {
                body.classList.remove('modal-open');
                body.style.paddingRight = '';
                if (body.contains(background)) {
                    body.removeChild(background);
                }
            }
        };
    }, []);

    return (
        <div className="modal fade in" style={{ display: 'block' }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">{children}</div>
            </div>
        </div>
    );
};

export default ModalXLarge;
